import { SOFTLINE_PERMISSION_ESL_STORAGE } from './esl-link-storage.shared';
import { ItemService } from '@softapps/handel/esl/core';
import { EslLinkStorageRepository } from './repositories/esl-link-storage.repository';
import { EslLinkStorageService } from './services/esl-link-storage.service';
import { Route } from '@angular/router';
import { SOFTLINE_PERMISSION_ESL } from '@softapps/handel/esl-link';

export const eslLinkStorageRoutes: Route[] = [
  {
    path: 'esl-link-storage',
    children: [
      {
        path: '',
        providers: [EslLinkStorageRepository, EslLinkStorageService],
        children: [
          {
            path: 'selection',
            loadComponent: () =>
              import('./pages/storage-selection/storage-selection.component').then(
                (m) => m.StorageSelectionComponent
              ),
          },
          {
            path: 'dissociate',
            loadComponent: () =>
              import('./pages/dissociate/dissociate.component').then(
                (o) => o.DissociateComponent
              ),
          },
          {
            path: ':storageId',
            children: [
              {
                path: 'associate',
                loadComponent: () =>
                  import('./pages/associate/associate.component').then(
                    (o) => o.AssociateComponent
                  ),
              },
              {
                path: 'associate/:esl',
                loadComponent: () =>
                  import('./pages/associate-items/associate-items.component').then(
                    (o) => o.AssociateItemsComponent
                  ),
              },
              { path: '**', redirectTo: '/esl-link-storage/:location/associate' },
            ],
          },
        ],
      },
      { path: '**', redirectTo: '/esl-link-storage/selection' },
    ],
    data: { permission: SOFTLINE_PERMISSION_ESL_STORAGE },
    providers: [ItemService],
  },
];

export const eslLinkRoutes: Route[] = [
  {
    path: 'esl-link',
    children: [
      {
        path: '',
        providers: [EslLinkStorageRepository, EslLinkStorageService],
        children: [
          {
            path: 'dissociate',
            loadComponent: () =>
              import('./pages/dissociate/dissociate.component').then(
                (o) => o.DissociateComponent
              ),
          },
          {
            path: 'associate',
            loadComponent: () =>
              import('./pages/associate/associate.component').then(
                (o) => o.AssociateComponent
              ),
          },
          {
            path: 'associate/:esl',
            loadComponent: () =>
              import('./pages/associate-items/associate-items.component').then(
                (o) => o.AssociateItemsComponent
              ),
          },
        ],
      },
      { path: '**', redirectTo: '/esl-link/associate' },
    ],
    data: { permission: SOFTLINE_PERMISSION_ESL_STORAGE },
    providers: [ItemService],
  },
];

export const eslSearchRoutes: Route[] = [
  {
    path: 'esl-search',
    children: [
      {
        path: '',
        children: [
          {
            path: 'flash',
            loadComponent: () =>
              import('./pages/search/search.component').then((m) => m.SearchComponent),
          },
        ],
      },
      { path: '**', redirectTo: '/esl-search/flash' },
    ],
    data: { permission: SOFTLINE_PERMISSION_ESL }
  },
];
